import axios from "axios";

export class apiAuthorize {
  // 获取系统授权信息
  static getEnhancedSystemConfig(queryParams) {
    const query = queryParams;
    return axios({
      url: "/sysConfig/getEnhancedSystemConfig",
      method: "GET",
      params: query,
    });
  }
}
